import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Snackbar, Alert
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { DELETE_MUTATION } from "../graphql/mutations";

const DeleteConfirmationDialog = ({ open, onClose, user }) => {
  const [deletemutation, { loading }] = useMutation(DELETE_MUTATION);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const isSuperUser = user?.Role?.toLowerCase() === "superuser";

  const handleDelete = async () => {
    try {
      await deletemutation({ variables: { id: user.id } });
      setSnackbarMessage("Member deleted successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      onClose();
      window.location.reload();
    } catch (error) {
      const apiMessage = error?.graphQLErrors?.[0]?.message || "Failed to delete member.";
      setSnackbarMessage(apiMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      onClose();
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>
          {isSuperUser ? "Action Not Allowed" : "Confirm Deletion"}
        </DialogTitle>

        <DialogContent>
          {isSuperUser ? (
            <Typography sx={{ mt: 1 }}>
              Superuser cannot delete another <strong>Superuser</strong> .
            </Typography>
          ) : (
            <>
              <Typography>
                Are you sure you want to delete the following member?
              </Typography>
              <Typography variant="subtitle1" sx={{ mt: 2 }}>
                <b>Name:</b> {user?.First_Name || "N/A"}<br />
                <b>Member ID:</b> {user?.id || "N/A"}<br />
                <b>Mobile:</b> {user?.Mobile_Number || "N/A"}<br />
                <b>Role:</b> {user?.Role || "N/A"}
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          {!isSuperUser && (
            <Button
              onClick={handleDelete}
              color="error"
              disabled={loading}
              sx={{ color: "red" }}
            >
              {loading ? "Deleting..." : "Delete"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteConfirmationDialog;
